import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { dietModeService } from "../../../services/settings-services";

const initialState = {
  dietModes: [],
  status: null,
  error: null,
  trigger: 0,
};

const getAllDietModes = createAsyncThunk(
  "dietModeSlice/getAllDietModes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await dietModeService.getAll();
      return response;
    } catch (e) {
      return rejectWithValue(
        e.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const dietModeSlice = createSlice({
  name: "dietModeSlice",
  initialState,
  reducers: {
    changeTrigger: (state, action) => {
      state.trigger = state.trigger + 1;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getAllDietModes.pending, (state) => {
        state.status = "Loading";
        state.error = null;
      })
      .addCase(getAllDietModes.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.dietModes = action.payload;
      })
      .addCase(getAllDietModes.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      }),
});

const { reducer: dietModeReducer, actions } = dietModeSlice;
const dietModeActions = {
  ...actions,
  getAllDietModes,
};

export { dietModeReducer, dietModeActions };

